import {
  PageTitle_default
} from "./chunk-3YANOUQQ.js";
import "./chunk-W5IFUZB5.js";
import {
  button_default,
  card_default,
  form_default,
  input_default
} from "./chunk-KX4LJVNT.js";
import {
  EditOutlined_default
} from "./chunk-Z6O4S4Q7.js";
import "./chunk-2JWEPRN7.js";
import "./chunk-JYAP7RUW.js";
import {
  styled_components_browser_esm_default
} from "./chunk-OMPJY3VL.js";
import "./chunk-FDUCPDRR.js";
import "./chunk-KWUZEEQS.js";
import "./chunk-WGLPVN3I.js";
import "./chunk-RDM77AGB.js";
import "./chunk-PUGBPE4F.js";
import {
  require_react
} from "./chunk-BODSDBIB.js";
import {
  Auth
} from "./chunk-GY7KB467.js";
import "./chunk-O4PJFSPJ.js";
import "./chunk-DZIKNQT5.js";
import "./chunk-5G5NRCK2.js";
import "./chunk-3N3MIKLS.js";
import "./chunk-U3RDFDRR.js";
import {
  __toESM
} from "./chunk-TFWDKVI3.js";

// node_modules/@myportal/ecedo-myportal-frontend-components/components/OrganizationTool/index.js
var import_react2 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/OrganizationTool/elements/CustomAttributeForm.js
var import_react = __toESM(require_react());
var __makeTemplateObject = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var FormButton = styled_components_browser_esm_default(button_default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  background-color: #4299e1;\n  color: white;\n  font-weight: 700;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  border-radius: 0.25rem;\n  height: 2.25rem;\n"], ["\n  display: flex;\n  align-items: center;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  background-color: #4299e1;\n  color: white;\n  font-weight: 700;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  border-radius: 0.25rem;\n  height: 2.25rem;\n"])));
var FormItem = styled_components_browser_esm_default(form_default.Item)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .ant-form-item-label {\n    label {\n      display: block;\n      font-weight: 700;\n      margin-bottom: 0.5rem;\n      padding-right: 1rem;\n      font-size: 1rem;\n    }\n  }\n"], ["\n  .ant-form-item-label {\n    label {\n      display: block;\n      font-weight: 700;\n      margin-bottom: 0.5rem;\n      padding-right: 1rem;\n      font-size: 1rem;\n    }\n  }\n"])));
var FormButtonContainer = styled_components_browser_esm_default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 1rem;\n"], ["\n  margin-top: 1rem;\n"])));
var FormInput = styled_components_browser_esm_default(input_default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 2px solid #edf2f7;\n  border-radius: 0.25rem;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  line-height: 1.25;\n  font-size: 1rem;\n  width: 75%;\n"], ["\n  border: 2px solid #edf2f7;\n  border-radius: 0.25rem;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  line-height: 1.25;\n  font-size: 1rem;\n  width: 75%;\n"])));
var CustomAttributeForm = function(_a) {
  var user = _a.user, handleRefresh = _a.handleRefresh;
  var _b = __read(form_default.useForm(), 1), form = _b[0];
  var _c = __read((0, import_react.useState)(false), 2), pending = _c[0], setPending = _c[1];
  var handleChange = (0, import_react.useCallback)(function(value) {
    return __awaiter(void 0, void 0, void 0, function() {
      var currentSession, e_1;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            _a2.trys.push([0, 4, , 5]);
            setPending(true);
            return [4, Auth.updateUserAttributes(user, {
              "custom:OrganizationID": value.organizationId
            })];
          case 1:
            _a2.sent();
            return [4, Auth.currentSession()];
          case 2:
            currentSession = _a2.sent();
            return [4, user.refreshSession(currentSession.getRefreshToken(), function() {
              handleRefresh();
            })];
          case 3:
            _a2.sent();
            return [3, 5];
          case 4:
            e_1 = _a2.sent();
            console.error(e_1);
            return [3, 5];
          case 5:
            setPending(false);
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [user]);
  return import_react.default.createElement(
    form_default,
    { form, onFinish: handleChange, layout: "vertical" },
    import_react.default.createElement(
      FormItem,
      { name: "organizationId", label: "Organization Id", rules: [{ required: true, message: "OrganizationId is required!" }] },
      import_react.default.createElement(FormInput, { placeholder: "Organization Id" })
    ),
    import_react.default.createElement(
      FormButtonContainer,
      null,
      import_react.default.createElement(FormButton, { htmlType: "submit", loading: pending, icon: import_react.default.createElement(EditOutlined_default, null) }, "Change")
    )
  );
};
var CustomAttributeForm_default = CustomAttributeForm;
var templateObject_1;
var templateObject_2;
var templateObject_3;
var templateObject_4;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/OrganizationTool/index.js
var __makeTemplateObject2 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter2 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator2 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read2 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var Container = styled_components_browser_esm_default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject2(["\n  display: flex;\n  align-items: stretch;\n"], ["\n  display: flex;\n  align-items: stretch;\n"])));
var Box = styled_components_browser_esm_default(card_default)(templateObject_22 || (templateObject_22 = __makeTemplateObject2(["\n  display: flex;\n  align-items: center;\n  padding: 1.5rem;\n  width: 100%;\n\n  .ant-card-body {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 1.5rem;\n  width: 100%;\n\n  .ant-card-body {\n    width: 100%;\n  }\n"])));
var OrganizationTool = function(_a) {
  var _b = _a.handleRefresh, handleRefresh = _b === void 0 ? function() {
    return console.warn("Refresh handler is not implemented!");
  } : _b;
  var _c = __read2((0, import_react2.useState)(null), 2), user = _c[0], setUser = _c[1];
  (0, import_react2.useEffect)(function() {
    var getUser = function() {
      return __awaiter2(void 0, void 0, void 0, function() {
        return __generator2(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, Auth.currentAuthenticatedUser()];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    getUser().then(function(currentUser) {
      return setUser(currentUser);
    }).catch(function(e) {
      return console.error(e);
    });
  }, []);
  return import_react2.default.createElement(
    import_react2.default.Fragment,
    null,
    import_react2.default.createElement(PageTitle_default, { title: "Organization Tool", subtitle: "An easy way to impersonate a user." }),
    import_react2.default.createElement(
      Container,
      null,
      import_react2.default.createElement(
        Box,
        null,
        import_react2.default.createElement(CustomAttributeForm_default, { user, handleRefresh })
      )
    )
  );
};
var OrganizationTool_default = OrganizationTool;
var templateObject_12;
var templateObject_22;
export {
  OrganizationTool_default as default
};
//# sourceMappingURL=@myportal_ecedo-myportal-frontend-components_components_OrganizationTool.js.map
